import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=73c80252&scoped=true&"
import script from "./Tabs.vue?vue&type=script&lang=js&"
export * from "./Tabs.vue?vue&type=script&lang=js&"
import style0 from "@/tbs/stylesheet/dynamic.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./Tabs.vue?vue&type=style&index=1&id=73c80252&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c80252",
  null
  
)

export default component.exports